import { render, staticRenderFns } from "./breeder-mating-list-component.vue?vue&type=template&id=fc1c1350&scoped=true&lang=pug"
import script from "./breeder-mating-list-component.js?vue&type=script&lang=js&external"
export * from "./breeder-mating-list-component.js?vue&type=script&lang=js&external"
import style0 from "./breeder-mating-list-component.vue?vue&type=style&index=0&id=fc1c1350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1c1350",
  null
  
)

export default component.exports